/**
 * i18n system - Main exports
 */

// Export core functions
export { 
  t, 
  getTranslation, 
  getLanguage, 
  setLanguage, 
  initializeI18n, 

  authMessages,
  authToastMessages,
  kpiDescriptions
} from './core';

// Export types
export type { 
  LanguageCode,
  TranslationFunction,
  TranslationKeys,
  KPICardData
} from './core';

export type { AllTranslations } from './translations';

 
